<template>
  <div>
    <reports-main></reports-main>
  </div>
</template>

<script>
import ReportsMain from "@/components/ecologist/reports/reportsMain";
export default {
  name: "reportsMainView",
  components: { ReportsMain },
};
</script>

<style scoped></style>
